import { render, staticRenderFns } from "./TransferStockFormModal.vue?vue&type=template&id=ca16b530&scoped=true&"
import script from "./TransferStockFormModal.vue?vue&type=script&lang=js&"
export * from "./TransferStockFormModal.vue?vue&type=script&lang=js&"
import style0 from "./TransferStockFormModal.vue?vue&type=style&index=0&id=ca16b530&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca16b530",
  null
  
)

export default component.exports